import { EditIcon, InfiniteTable } from '@/components/_common';
import { useStockTransferList } from '@/core/domain/stock/Operations/Operations.hooks';
import { StockTransfer } from '@/core/domain/stock/Operations/Operations.types';
import { flatInfiniteResult } from '@/utils/request/flatInfiniteResult';
import { getTableScrollX } from '@/utils/table';
import { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import { useIntl } from 'react-intl';

export default function StockTransferList() {
  const intl = useIntl();

  const stockTransfersList = useStockTransferList();

  const stockTransfers = flatInfiniteResult(stockTransfersList.data);

  const columns: ColumnsType<StockTransfer> = [
    {
      dataIndex: 'createdAt',
      title: 'Dt. transferência',
      width: 150,
      ellipsis: true,
      render: (value) =>
        value ? moment(value).format('DD/MM/YYYY HH:mm') : '-',
    },
    {
      dataIndex: ['sendCompany', 'companyName'],
      title: 'Empresa Origem',
      width: 150,
      ellipsis: true,
    },
    {
      dataIndex: ['receiveCompany', 'companyName'],
      title: 'Empresa Destino',
      width: 150,
      ellipsis: true,
    },
    {
      title: intl.formatMessage({ id: 'commons.list.header.action' }),
      width: 50,
      align: 'right',
      fixed: 'right',
      render(row: StockTransfer) {
        return (
          <EditIcon redirect={`/app/movements/stock-transfer/${row.id}`} />
        );
      },
    },
  ];

  return (
    <InfiniteTable<StockTransfer>
      size="small"
      columns={columns}
      dataSource={stockTransfers}
      rowKey={(row) => row.id}
      loading={stockTransfersList.isFetching}
      hasNextPage={stockTransfersList.hasNextPage}
      fetchNextPage={stockTransfersList.fetchNextPage}
      scroll={{ x: getTableScrollX(columns) }}
    />
  );
}
